import React from "react";
import PrintButton from "../PrintButton";

const SelectorDocuments = ({value, emptyMessage, disabled, loading}) => {
    if (value.length) {
        return <div className="selector-grid documents">{
            value.map((row) => {
                return <PrintButton url={row.path + row.filename} color={"default"}
                                    icon={{lib: "fa", name: "print"}}
                                    className={"pull-left"}
                                    disabled={disabled || loading}>{row.filename}</PrintButton>
            })
        }
            <div className="clearfix"/>
        </div>;
    } else {
        return emptyMessage;
    }
}

export default SelectorDocuments;